import CustomTextBox from "app/components/atoms/customTextBox";

export const profileRequestStatusUiSchema = {
  "ui:title": "",
  ctpt_employer: {
    "ui:widget": (props) => {
      return <CustomTextBox getProps={props} />;
    },
  },
  ctpt_name: {
    "ui:widget": (props) => {
      return <CustomTextBox getProps={props} />;
    },
  },
  ctpt_reasonforcontacting: {
    "ui:widget": (props) => {
      return <CustomTextBox getProps={props} />;
    },
  },
  ctpt_daterequested: {
    "ui:widget": (props) => {
      return <CustomTextBox getProps={props} />;
    },
  },
  ctpt_approved: {
    "ui:widget": (props) => {
      return <CustomTextBox getProps={props} />;
    },
  },
  ctpt_rejected: {
    "ui:widget": (props) => {
      return <CustomTextBox getProps={props} />;
    },
  },
  ctpt_employee: {
    "ui:widget": (props) => {
      return <CustomTextBox getProps={props} />;
    },
  },
};

